import { LocaleStringArray, SanityDiscussionSlide } from "@common";
import { localizedStringArrayToTranslationData } from "../translation";
import { TeacherModeQuizModule } from "@natklok/config/teacherModeQuizModules";
import { transformDiscussionSlide } from "./discussionSlide";

export interface SanityTeacherQuizModule {
  _type: "teacherQuizModule";
  _id: string;
  introSlideTitle: LocaleStringArray;
  introSlideDescription: LocaleStringArray;
  youtubeVideoId?: string;
  isExtraMaterial?: boolean;
  quizModule: {
    title: LocaleStringArray;
    desc: LocaleStringArray;
    slides: Array<{ _id: string }>;
  };
  discussionSlides: SanityDiscussionSlide[];
}

function transformSanityTeacherQuizModule(
  quizModule: SanityTeacherQuizModule
): TeacherModeQuizModule {
  return {
    introSlideTitle: localizedStringArrayToTranslationData(quizModule.introSlideTitle),
    introSlideDesc: localizedStringArrayToTranslationData(quizModule.introSlideDescription),
    title: localizedStringArrayToTranslationData(quizModule.quizModule.title),
    desc: localizedStringArrayToTranslationData(quizModule.quizModule.desc),
    youtubeID: quizModule.youtubeVideoId ?? "",
    isExtraMaterial: quizModule.isExtraMaterial || false,
    questionIdsOrVariants: quizModule.quizModule.slides.map((question) => question._id),
    discussionSlides: quizModule.discussionSlides.map(transformDiscussionSlide),
  };
}

export default transformSanityTeacherQuizModule;
